<sh-loading [message]="'login.state.loggingIn' | translate"></sh-loading>
